<div class="wrapper {{theme}}">
  <div class="chat-box" *ngIf="visible" [@fadeInOut]="visible">
    <div class="chat-box-header">
      <div class="">
        <div class="operator-status">
          {{operator.status}}
          <span [ngClass]="{
                  'operator-status-online': operator.status == 'online',
                  'operator-status-offline': operator.status == 'offline'}">●</span>
          <button class="chat-button-header" (click)="toggleChat()">✕</button>
        </div>
        <chat-avatar [image]="operator.avatar"></chat-avatar>
        <h3 class="operator-name">
          {{operator.name}}
        </h3>
      </div>
    </div>
    <div class="chat-box-main">
      <div class="chat-message-bottom" #bottom></div>
      <ng-container *ngFor="let message of messages">
        <div class="chat-message" [class.chat-message-received]="message.type === 'received'"
             [@fadeIn]
             [class.chat-message-sent]="message.type === 'sent'">
          <div >
            <chat-avatar [image]="message.from.avatar" class="chat-message-from-avatar"></chat-avatar>

            <div class="chat-message-text" style="text-align: justify;" *ngIf="!message.hasButtons">
              <div  [innerHTML]="message.text | sanitize"></div>
            </div>

            <div class="chat-message-text" *ngIf="message.hasButtons">
              <div  *ngFor="let button of message.buttons">
                <button  type="button"  class="btn btn-light button-margin mt-1"
                         (click)="callButtonAction(button.payload)" >
                  {{button.title}}
                </button>
              </div>
            </div>
          </div>
          <div class="chat-message-date">
            {{message.date | date: 'short'}}
          </div>
        </div>
      </ng-container>
    </div>
    <div class="chat-box-footer">
      <chat-input (send)="sendMessage($event)" (dismiss)="toggleChat()" [focus]="focus" (clear)="clear()"></chat-input>
    </div>
  </div>

  <a id="chatbot-text" *ngIf="!visible" (click)="toggleChat() ">
    <div id="chatbot-tooltip">
      <div id="chatbot-tooltip-inner">
        <span>Vorbeste cu Eva</span>
      </div>
    </div>

  </a>
  <button class="chat-button" (click)="toggleChat() ">
    <app-feather-icons  *ngIf="!visible" [icon]="'message-circle'" ></app-feather-icons>
    <app-feather-icons  *ngIf="visible" [icon]="'x'" >
    </app-feather-icons>
  </button>
</div>
